import React, { useState, useEffect } from "react";
import axios from "axios";

import Sidebar from "./Sidebar";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const Currentprice = () => {
  const navigate = useNavigate();
  const [currentgoldprice, setCurrentgoldprice] = useState([]);
  //get current price from databse
  useEffect(() => {
    const fetchCurrentPrice = async () => {
      try {
        const response = await axios.get(
          "/goldprice/admin/show"
        );
        setCurrentgoldprice(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchCurrentPrice();
  }, []);

  const [newPriceValue, setNewPriceValue] = useState("");

  const handleAddPrice = async (e) => {
    e.preventDefault();
    try {
      await axios.post("/goldprice/admin/add", { goldprice: newPriceValue });
      toast.success("Gold price added successfully!");
      window.location.reload();
    } catch (error) {
      toast.error("Failed to add gold price");
    }
  };

  return (
    <div className="flex bg-gray-50 min-h-screen">
      <Sidebar />
      <div className="flex-1 p-8 text-black">
        <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-2xl p-10 border border-gray-100">
          <h1 className="text-3xl font-extrabold text-gray-900 mb-8 border-b pb-4">
            Today's Gold Price Management
          </h1>

          {currentgoldprice.length > 0 ? (
            <div className="overflow-hidden rounded-lg border border-gray-200">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                       Active Price (Rs/g)
                    </th>
                    <th className="px-6 py-4 text-center text-xs font-semibold text-gray-500 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {currentgoldprice.map((price) => (
                    <tr key={price._id} className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4 whitespace-nowrap text-lg font-medium text-gray-800">
                        Rs {price.goldprice}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <Link
                          to={`/admin/update/price/${price._id}`}
                          className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-md shadow-sm transition-all"
                        >
                          <i className="fas fa-edit mr-2"></i> Update
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-300">
              <div className="mb-6">
                <i className="fas fa-coins text-4xl text-gray-300"></i>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">No Gold Price Set!</h3>
              <p className="text-gray-500 mb-6">You must set an initial gold price for product calculations to work.</p>
              
              <form onSubmit={handleAddPrice} className="max-w-xs mx-auto">
                <input 
                  type="number"
                  required
                  placeholder="Enter Price per gram"
                  value={newPriceValue}
                  onChange={(e) => setNewPriceValue(e.target.value)}
                  className="w-full px-4 py-2 mb-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                />
                <button 
                  type="submit"
                  className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded-lg transition-transform hover:scale-105 active:scale-95"
                >
                  Set Initial Price
                </button>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Currentprice;
